export const POSTER_TYPES = [
  "Woman",
  "Man",
  "Couple",
  "Trans woman",
  "Trans man",
  "Non-binary",
] as const;

export const SEEKING_TYPES = [...POSTER_TYPES, "Any"] as const;

export const CONNECTION_TYPES = [
  "NSA",
  "Friendship",
  "Drinking pals",
  "Dating",
  "Conversation",
  "Activity partner",
  "Events",
  "Other",
] as const;

